"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removePlugin = removePlugin;
exports.removeClient = removeClient;
const rpc = __importStar(require("vscode-jsonrpc/node"));
const connect_1 = __importDefault(require("../connect"));
/**
 * Removes a plugin from the Kiota environment.
 *
 * @param {RemovePluginConfiguration} config - The configuration for removing the plugin.
 * @param {string} config.pluginName - The name of the plugin to remove.
 * @param {boolean} config.cleanOutput - Whether to clean the output directory after removal.
 * @param {string} config.workingDirectory - The working directory where the operation should be performed.
 * @returns {Promise<KiotaResult | undefined>} A promise that resolves to a KiotaResult if the operation is successful, or undefined if no result is returned.
 * @throws {Error} Throws an error if the operation fails.
 */
async function removePlugin({ pluginName, cleanOutput, workingDirectory }) {
    const result = await (0, connect_1.default)(async (connection) => {
        const request = new rpc.RequestType2("RemovePlugin");
        return await connection.sendRequest(request, pluginName, cleanOutput);
    }, workingDirectory);
    if (result instanceof Error) {
        throw result;
    }
    if (result) {
        return {
            isSuccess: result.some(k => k.message.includes('removed successfully')),
            logs: result
        };
    }
    return undefined;
}
;
/**
 * Removes a client using the provided configuration.
 *
 * @param {RemoveClientConfiguration} config - The configuration for removing the client.
 * @param {string} config.clientName - The name of the client to be removed.
 * @param {boolean} config.cleanOutput - A flag indicating whether to clean the output.
 * @param {string} config.workingDirectory - The working directory for the operation.
 * @returns {Promise<KiotaResult | undefined>} A promise that resolves to a KiotaResult if the client was removed successfully, or undefined if no result is returned.
 * @throws {Error} Throws an error if the result is an instance of Error.
 */
async function removeClient({ clientName, cleanOutput, workingDirectory }) {
    const result = await (0, connect_1.default)(async (connection) => {
        const request = new rpc.RequestType2("RemoveClient");
        return await connection.sendRequest(request, clientName, cleanOutput);
    }, workingDirectory);
    if (result instanceof Error) {
        throw result;
    }
    if (result) {
        return {
            isSuccess: result.some(k => k.message.includes('removed successfully')),
            logs: result
        };
    }
    return undefined;
}
;
//# sourceMappingURL=removeItem.js.map